import * as React from 'react';

import type { IconProps } from '../../types';

/**
 * Trophy icon
 *
 * @category Business
 */
const Trophy = React.forwardRef<SVGSVGElement, IconProps>(
  ({ 'data-testid': testId, size = 20, className, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        data-testid={testId}
        width={size}
        height={size}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        role="img"
        aria-hidden="true"
        {...props}
      >
        <path
          fill="currentColor"
          d="M25.832 6.705c-.668-.068-1.743.181-1.8-.724-.023-.86 0-2.344-1.053-2.412-3.362-.034-11.83 0-13.732-.011-.362 0-.633.09-.905.43-.487.442-.125 1.981-.544 2.468-.543.419-1.46.136-2.128.328-3.543.578-3.577 5.717 0 6.294.759.17 1.823-.034 2.355.374.906 1.257 1.37 3.011 2.75 3.996 1.03.906 2.367 1.54 3.725 1.811.396.102.69.204.815.51.193.78.181 2.377 0 3.079-.124.306-.407.441-.78.566-1.303.385-2.503 1.29-3.16 2.502-.497.917-.86 2.343-.497 2.468.294.113 1.166.034 2.298.056h6.679c.94-.034 1.437.159 1.415-.396-.125-2.128-1.766-4.064-3.804-4.63-.306-.113-.668-.238-.781-.566-.159-.34-.102-.996-.113-1.687.022-.758-.08-1.211.294-1.641 1.438-.555 3.192-.906 4.358-2.083 1.382-.985 1.834-2.717 2.74-3.996.906-.532 2.219-.09 3.158-.623 3.046-1.302 2.185-5.887-1.132-6.113h-.192zM5.976 11.98c-1.823-.226-2.513-2.784-.872-3.758.532-.317 1.166-.408 1.789-.408.475 0 .94-.034 1.143.397.204.69.045 1.833.09 2.615 0 .452-.022.826-.226 1.018-.373.306-1.234.193-1.754.17l-.181-.022zm14.06 15.34c-2.06-.068-5.977.124-8.004-.068 1.076-3.906 6.917-3.872 7.993 0v.068zm2.637-15.192c-.962 7.686-11.875 8.456-13.29.056-.237-2.185-.407-4.675.023-6.77.192-1.188 3.09-.713 4.823-.803 2.207.113 6.045-.283 7.731.26 1.381.906.759 3.17.883 5.06a15 15 0 0 1-.147 1.993l-.034.215zm3.034-.102c-2.332.271-1.709-.85-1.788-2.593 0-.622-.057-1.234.283-1.449.803-.385 2.603-.18 3.237.657 1.087 1.279.068 3.283-1.54 3.373l-.18.023z"
        />
      </svg>
    );
  }
);

Trophy.displayName = 'Trophy';

export { Trophy };
